<template>
<div class="devices-page">
  <h1 class="page-title">
    <div class="text-right">
       <b-button
           v-if="deviceOnline"
              class="actionButton"
              id="downloadButton"
              variant="primary"
              size="sm"
              @click.prevent="requestLog()">
                Request Logs
        </b-button>
    </div>

  </h1>

<b-tabs>
    <div>
      <ResponsiveTable
          v-if="logFilesData.length"
          :fields="fields"
          :items="logFilesData"
          :searchable_fields="searchableFields"
          sort-by="request_date"
          sort-direction="asc"
      >
        <template v-slot:cell(actions)="row">
            <b-button
              v-if="$base.isAllowed('editDeviceConfiguration')"
              class="actionButton"
              id="deleteButton"
              variant="primary"
              size="sm"
              @click.prevent="deleteHistoryLog(row.item.uuid)">
                <i class="fas fa-trash"></i>
            </b-button>
            <b-button
              class="actionButton"
              id="downloadButton"
              v-if="row.item.status === 'DOWNLOADED'"
              variant="primary"
              size="sm"
              @click.prevent="downloadLog(row.item.filename, row.item.uuid)">
                <i class="fas fa-download"></i>
            </b-button>
        </template>
      </ResponsiveTable>
      <h1
          v-else
          class="text-center"
      >
        No data to show
      </h1>
    </div>

</b-tabs>
</div>
</template>

<script>
import {
  mapActions,
  mapGetters,
} from 'vuex';
import datetimeFormatter from '@/core/datetimeFormatterHelper';
import FormInputWithClearButton from '@/components/FormInputWithClearButton/FormInputWithClearButton';
import InstallationModal from '@/components/InstallationModal/InstallationModal';
import DeviceUpgradeModal from '@/components/DeviceUpgradeModal/DeviceUpgradeModal';
import UninstallationModal from '@/components/UninstallationModal/UninstallationModal';
import InstallationIssues from '@/components/Device/InstallationIssues/InstallationIssues';
import InstallationLog from '@/components/Device/InstallationLog/InstallationLog';
import { deviceService } from "@/_services";
import ResponsiveTable from "@/components/ResponsiveTable/ResponsiveTable";

export default {
  name: 'Devices',
  components: {
    ResponsiveTable,
    FormInputWithClearButton,
    InstallationModal,
    DeviceUpgradeModal,
    UninstallationModal,
    InstallationIssues,
    InstallationLog
  },
  data() {
    return {
      sortBy: 'request_time',
      sortDesc: false,
      isBusy: false,
      fields: [
        {
          key: 'filename',
          label: 'File Name',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'request_time',
          label: 'Request Date',
          sortable: true,
          sortDirection: 'asc',
          formatter: datetimeFormatter,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'actions',
          label: 'ACTIONS',
          class: 'actions_buttons'
        }
      ],
      searchableFields: [
          "file_name",
          "request_state",
          'status',
      ],
      search: '',
      logFilesData: []
    }
  },
  computed: {
    ...mapGetters('device', ['deviceOnline']),
  },
  watch: {
  },
  methods: {
    ...mapActions('alert', ['success', 'error']),
    datetimeFormatter,
    deleteHistoryLog(uuid) {
      deviceService.deleteHistoryLog(this.$route.params.serial, uuid).then(() => {
        this.success("Successfully deleted log file")
      }).catch(() => {
        this.error("Error while deleting log file")
      })
    },
    downloadLog(filename, uuid_) {
      deviceService.downloadLog(this.$route.params.serial, uuid_).then((response) => {
        let url = window.URL.createObjectURL(new Blob([response.data]))
        let link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      }).catch(() => {
        this.error("File is not present on the server, couldn't download")
      })
    },
    requestLog() {
      deviceService.requestDownloadLogs(this.$route.params.serial).then(() => {
        this.success("Successfully requested download logs");
      }).catch(() => {
        this.error("Error while requesting downloading logs")
      })
    },
    updateLogData() {
    deviceService.getLogsData(this.$route.params.serial).then(response => {
      this.logFilesData = response.data["logs"]
    })
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.updateLogData()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
};
</script>

<style src="./LogsTab.scss" lang="scss" />
